<template>
  <div>
    <div v-for="(item, index) in inventoryForm.data"
         :key="index">
      <b-row
        class="d-flex align-items-start">
        <b-col xl="1" lg="3" md="3" sm="3" cols="12">
          <validation-provider
            :ref="'ModeCode-' + index"
            :name="'ModeCode-' + index"
            :rules="{ max: 5, min: 5,  regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              :id="'input-group-1-' + index"
              class="form-input-wrapper"
              label-class="form-label"
              :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                :id="'input-1-' + index"
                class="form-input"
                v-model="item.ModeCode"
                placeholder="Код"
                v-b-tooltip.hover :title="item.ModeCode"
                @change="updateIdbData"
                :state="getValidationState(validationContext)"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="3" md="3" sm="3" cols="12">
          <validation-provider
            :ref="'DocName-' + index"
            :name="'Наименование документа-' + index"
            :rules="{ required: true, max: 250 }"
            v-slot="validationContext">
            <b-form-group
              :id="'input-group-2-' + index"
              class="form-input-wrapper"
              label-class="form-label"
              :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                :id="'input-2-' + index"
                class="form-input"
                v-model="item.DocName"
                placeholder="Наименование"
                v-b-tooltip.hover :title="item.DocName"
                @change="updateIdbData"
                :state="getValidationState(validationContext)"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="3" md="3" sm="3" cols="12">
          <validation-provider
            :ref="'RegNum-' + index"
            :name="'Номер документа-' + index"
            :rules="{ required: true, max: 50 }"
            v-slot="validationContext">
            <b-form-group
              :id="'input-group-3-' + index"
              class="form-input-wrapper"
              label-class="form-label"
              :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                :id="'input-3-' + index"
                class="form-input"
                v-model="item.RegNum"
                placeholder="Номер"
                v-b-tooltip.hover :title="item.RegNum"
                @change="updateIdbData"
                :state="getValidationState(validationContext)"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="3" md="3" sm="3" cols="12">
          <custom-datepicker
            class="w-100"
            :ref="'RegDate-' + index"
            :inputId="'RegDate-' + index"
            :inputName="'Дата документа-' + index"
            :index="index"
            customPlaceholder="Дата"
            :inputValidationRules="{ required: true, regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
            @setForm="setModel($event)"
          ></custom-datepicker>
        </b-col>
        <b-col xl="4" lg="8" md="8" sm="8" cols="12">
          <div class="d-flex align-items-start justify-content-between">
            <validation-provider
              style="width: 80%"
              :ref="'File-' + index"
              :name="'Файл-' + index"
              :rules="{ required: (item.FileName === 'Файл не выбран') }"
              v-slot="validationContext">
              <b-form-group
                :id="'input-group-5-' + index"
                class="form-input-wrapper"
                label-class="form-label"
                :invalid-feedback="validationContext.errors[0]">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      v-if="(item.FileName !== 'Файл не выбран') && (item.did === null)"
                      @click="removeFile(index)"
                      squared
                      size="sm"
                      variant="outline-secondary">
                      <font-awesome-icon icon="fa-solid fa-xmark"/>
                    </b-button>
                  </b-input-group-prepend>
                  <span style="width: calc(100% - 94px)" v-b-tooltip.hover
                        :title="(!item.ModeCode || !item.DocName || !item.RegNum || !item.RegDate) ? 'Необходимо указать код, наименование, номер, дату документа' : ''">
                    <b-form-file
                      :key="item.key"
                      class="d-block"
                      :id="'file-' + index"
                      v-model="item.file"
                      :disabled="(!item.ModeCode || !item.DocName || !item.RegNum || !item.RegDate)"
                      :placeholder="item.FileName"
                      browse-text="!"
                      @change="onChangeFileInput"
                      :state="getValidationState(validationContext)"
                      size="sm"
                      required
                      accept=".jpg, .png, .pdf, .doc, .docx">
                    </b-form-file>
                  </span>
                  <b-input-group-append>
                    <b-button
                      v-if="item.did"
                      :disabled="(!item.ModeCode || !item.DocName || !item.RegNum || !item.RegDate) || (item.did === null)"
                      squared
                      size="sm"
                      @click="downloadFreeBinaryDoc(item)"
                      variant="outline-success">
                      <font-awesome-icon icon="fa-solid fa-download"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <span class="custom-invalid-feedback">{{ validationContext.errors[0] }}</span>
              </b-form-group>
            </validation-provider>
          </div>
        </b-col>
        <b-col xl="1" lg="4" md="4" sm="4" cols="12">
          <div class="d-flex flex-nowrap align-items-center justify-content-end">
            <b-button @click="removeDocument(index, item.did)"
                      :class="{ 'ml-3': true, 'mr-3': index === (inventoryForm.data.length - 1), 'mb-3': mobile }"
                      squared size="sm" variant="outline-secondary">
              <font-awesome-icon icon="fa-solid fa-minus"/>
            </b-button>
            <b-button v-if="index === (inventoryForm.data.length - 1)"
                      :class="{ 'mb-3': mobile }"
                      @click="addDocument(index)" squared size="sm" variant="outline-success">
              <font-awesome-icon icon="fa-solid fa-plus"/>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <hr v-if="largeDesktop || desktop || tablet">
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import CustomDatepicker from '../../CustomDatepicker'

  export default {
    name: "InventoryPage",
    props: ['getValidationState', 'freeBinaryDocs', 'targetInput', 'parentType'],
    components: {
      CustomDatepicker
    },
    data () {
      return {
        inventoryForm: {
          data: []
          }
        }
    },
    watch: {
        freeBinaryDocs(val) {
          this.inventoryForm = Object.assign(this.inventoryForm, {data: val})
          for (let i = 0; i < this.inventoryForm.data.length; i++) {
            this.$nextTick(() => {
              this.$refs['RegDate-' + i][0].model = this.inventoryForm.data[i].RegDate
            })
          }
        }
    },
    computed: {
      ...mapState(
        {
          packagePid: state => state.houseShipment.packagePid,
          packageChainid: state => state.houseShipment.packageChainid,
          packageStatus: state => state.houseShipment.packageStatus,
          nsiDocuments: state => state.commissionShipment.nsiDocuments,
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop
        }
      )
    },
    mounted() {
    },
    methods: {
      setModel (event) {
        if (('index' in event) && (event.index !== null)) {
          const name = event.fieldName.split('-')[0]
          this.inventoryForm.data[event.index][name] = event.item
        }
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      updateIdbData () {
        this.$emit('updateDocs')
      },
      removeFile (index) {
        this.inventoryForm.data[index].FileName = 'Файл не выбран'
        this.inventoryForm.data[index].FileData = null
        this.inventoryForm.data[index].file = null
      },
      async removeDocument (index, did) {
        if (this.inventoryForm.data.length > 1) {
          if (did) {
            await this.deleteFreeBinaryDoc({ pid: this.$route.params.pid, did: did }).then(
              () => {
                this.inventoryForm.data.splice(index, 1)
              },
              (error) => {
                console.log(error)
              }
            )
          } else {
            this.inventoryForm.data.splice(index, 1)
          }
        } else {
          if (did) {
            await this.deleteFreeBinaryDoc({ pid: this.$route.params.pid, did: did }).then(
              () => {
                this.resetFormData()
                this.$emit('removeInventoryTab')
              },
              (error) => {
                console.log(error)
              }
            )
          } else {
              this.resetFormData()
          }
        }
        if (this.inventoryForm.data[index]) {
          this.inventoryForm.data[index].key += 1
        }
        this.updateIdbData()
      },
      addDocument () {
        this.inventoryForm.data.push(
          {
            key: Math.random(),
            file: null,
            FileName: 'Файл не выбран',
            did: null,
            DOC_ID: null,
            ModeCode: '09023', // Код документа
            DocName: null, // Наименование документа
            RegNum: null, // Номер документа
            RegDate: null, // Дата документа
            FileData: null,
          }
        )
      },
      downloadFreeBinaryDoc (item) {
        this.downloadFreeBinaryDocData({ pid: this.$route.params.pid, did: item.did }).then(
          () => {
            const fileName = item.FileData.split(';')[0]
            const ext = fileName.split('.')[1]
            let contentType = null
            switch (ext) {
              case 'jpg':
              case 'jpeg':
                contentType = 'image/jpeg'
                break
              case 'png':
                contentType = 'image/png'
                break
              case 'pdf':
                contentType = 'application/pdf'
                break
              case 'doc':
                contentType = 'application/msword'
                break
              case 'docx':
                contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                break
            }
            const base64Data = item.FileData.split(';')[1]
            const linkSource = `data:${ contentType };base64,${ base64Data }`
            const downloadLink = document.createElement("a")
            downloadLink.href = linkSource
            downloadLink.download = fileName
            downloadLink.click()
          },
          (error) => {
            console.log(error)
          }
        )
      },
      isNewPackageInChain () {
        const isNewPackageInChain = [94, 273, 266, 4, 6].find((item) => {
          return item === parseInt(this.packageStatus)
        })
        return !!isNewPackageInChain
      },
      getPackagePid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && (this.$route.name === 'EditCommissionShipment')) {
          return null
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditCommissionShipment')) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditCommissionShipment')) {
          return this.$route.params.pid
        }
      },
      getPackageChanid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && (this.$route.name === 'EditHouseShipment')) {
          return this.packageChainid
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditHouseShipment')) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditHouseShipment')) {
          return null
        }
      },
      getBase64 (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            resolve(reader.result)
          }
          reader.onerror = function (error) {
            console.log('Error: ', error)
            reject(error)
          }
        })
      },
      onChangeFileInput (event) {
        const index = event.target.id.split('-')[1]
        if (event.target.files.length > 0) {
          if ((event.target.files[0].size / 1024 / 1024) > 3) {
            const toastMessage = 'Размер вашего файла ' + this.calcFileSize(event.target.files[0].size)
            this.$bvToast.toast(toastMessage, {
              title: 'Ошибка! Размер файла не должен превышать 3 Мб',
              variant: 'danger',
              name: 'b-toaster-top-center'
            })
            this.inventoryForm.data[index].FileData = null
          } else {
            this.$nextTick(() => {
              this.inventoryForm.data[index].FileName = event.target.files[0].name
              const document = this.inventoryForm.data[index]
              const fileBlob = event.target.files[0]
              this.getBase64(fileBlob).then(
                (fileBase64) => {
                  const ind = fileBase64.indexOf(',') + 1
                  const fileBase64cutted = fileBase64.substr(ind)
                  this.inventoryForm.data[index] = Object.assign({}, {...document,
                    FileName: event.target.files[0].name,
                    FileData: event.target.files[0].name + ';' + fileBase64cutted,
                    file: event.target.files[0]
                  })
                  this.updateIdbData()
                },
                (error) => {
                  console.log(error)
                }
              )
            })
          }
        }
      },
      calcFileSize (FileSize) {
        const FileSizeInKb = Math.floor(FileSize / 1024)
        let FileSizeInMb = 0
        let FileSizeInGb = 0
        if (FileSizeInKb > 0) {
          FileSizeInMb = Math.floor(FileSizeInKb / 1024)
          if (FileSizeInMb > 0) {
            FileSizeInGb = Math.floor(FileSizeInMb / 1024)
            if (FileSizeInGb > 0) {
              return FileSizeInGb + ' Гб'
            } else {
              return FileSizeInMb + ' Мб'
            }
          } else {
            return FileSizeInKb + ' Кб'
          }
        } else {
          return FileSize + ' байт'
        }
      },
      resetFormData () {
         const InventDocLn = this.inventoryForm.data.length
         this.inventoryForm.data.splice(1, (InventDocLn - 1))
         if (this.inventoryForm.data[0]) {
           const itemProps = Object.getOwnPropertyNames(this.inventoryForm.data[0])
           for (let j = 0; j < itemProps.length; j++) {
             if (itemProps[j] === 'key') {
               this.inventoryForm.data[0].key = Math.random()
             } else if (itemProps[j] === 'filename') {
               this.inventoryForm.data[0].filename = 'Файл не выбран'
             } else if (itemProps[j] === 'ModeCode') {
               this.inventoryForm.data[0].ModeCode = '09023'
             } else {
               this.inventoryForm.data[0][itemProps[j]] = null
             }
           }
         }
      },
      ...mapActions({
        downloadFreeBinaryDocData: 'houseShipment/downloadFreeBinaryDocData',
        createFreeBinaryDoc: 'commissionShipment/createFreeBinaryDoc',
        editFreeBinaryDoc: 'commissionShipment/editFreeBinaryDoc',
        deleteFreeBinaryDoc: 'houseShipment/deleteFreeBinaryDoc',
      })
    }
  }
</script>

<style lang="scss" scoped>
  .reset-file-btn {
    height: 28px;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  hr {
    margin-top: 0 !important;
  }
</style>
